import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/components/legal/DataRequestForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/app/components/PublicHeader.tsx");
